{
  "days": {
    "friday": "Пятница",
    "monday": "Понедельник",
    "saturday": "Суббота",
    "sunday": "Воскресенье",
    "thursday": "Четверг",
    "tuesday": "Вторник",
    "wednesday": "Среда"
  },
  "discover": {
    "explore": "Изучить Локации"
  },
  "explore_list": {
    "description": "Этот список извлечён из {wikipage}.",
    "error": "Ошибка при загрузке списка.",
    "subtitle": "{city} - {nation}",
    "title": "Посмотреть",
    "wikipage": "Вики страница, посвящённая Простой схеме тегирования внутренних планов зданий"
  },
  "heatmap": {
    "hide": "Скрыть тепловую карту",
    "show": "Показать тепловую карту"
  },
  "opening_hours": {
    "state": {
      "closed": "закрыто",
      "open": "открыто"
    },
    "state_until_date": "{state} до {date}",
    "tomorrow": "завтра",
    "url": "Посетить веб сайт, для уточнения часов работы"
  },
  "poi": {
    "aerialway": {
      "station": "Станция"
    },
    "aeroway": {
      "gate": "Гейт аэропорта"
    },
    "amenity": {
      "arts_centre": "Центр творчества",
      "atm": "Банкомат",
      "bank": "Банк",
      "bar": "Бар",
      "bbq": "Барбекю",
      "bench": "Скамья",
      "bicycle_parking": "Велопарковка",
      "bicycle_rental": "Велопрокат",
      "biergarten": "Пивной сад",
      "bureau_de_change": "Обмен валюты",
      "bus_station": "Автовокзал",
      "cafe": "Кафе",
      "car_rental": "Автопрокат",
      "cinema": "Кино",
      "clinic": "Больница",
      "college": "Колледж",
      "community_centre": "Общественный центр",
      "courthouse": "Здание суда",
      "dentist": "Стоматолог",
      "doctors": "Медицинский кабинет",
      "embassy": "Посольство",
      "fast_food": "Фастфуд",
      "ferry_terminal": "Речной паром",
      "fire_station": "Пожарная станция",
      "food_court": "Ресторанный дворик",
      "fuel": "Автозаправка",
      "grave_yard": "Похоронная контора",
      "hospital": "Больница",
      "ice_cream": "Мороженое",
      "kindergarten": "Детский сад",
      "library": "Библиотека",
      "marketplace": "Рынок",
      "motorcycle_parking": "Парковка мотоциклов",
      "nightclub": "Ночной клуб",
      "nursing_home": "Дом престарелых",
      "parking": "Парковка",
      "pharmacy": "Аптека",
      "photo_booth": "Фотобудка",
      "piano": "Пианино в общем доступе",
      "place_of_worship": "Храм",
      "police": "Полиция",
      "post_box": "Почтовый ящик",
      "post_office": "Отделение почты",
      "prison": "Тюрьма",
      "pub": "Паб",
      "public_building": "Общественное здание",
      "recycling": "Переработка отходов",
      "restaurant": "Ресторан",
      "school": "Школа",
      "shelter": "Укрытие",
      "swimming_pool": "Бассейн",
      "taxi": "Такси",
      "telephone": "Телефон",
      "theatre": "Театр",
      "ticket_validator": "Валидатор билетов",
      "toilets": "Туалет",
      "townhall": "Ратуша",
      "university": "Университет",
      "vending_machine": "Автомат по продаже",
      "veterinary": "Ветеринарная клиника",
      "waste_basket": "Урна для мусора"
    },
    "barrier": {
      "bollard": "Столбик",
      "border_control": "Пограничный контроль",
      "cycle_barrier": "Велосипедный барьер",
      "gate": "Ворота",
      "lift_gate": "Шлагбаум",
      "sally_port": "Ворота для вылазки",
      "stile": "Перелаз",
      "toll_booth": "Пункт взимания платы"
    },
    "craft": {
      "brewery": "Пивоварня",
      "caterer": "Кейтеринг",
      "confectionery": "Кондитерская",
      "dressmaker": "Пошив одежды",
      "electronics_repair": "Ремонт электроники",
      "shoemaker": "Сапожник",
      "tailor": "Портной"
    },
    "door": {
      "door": "Дверь",
      "hinged": "Дверь",
      "no": "Дверь",
      "overhead": "Дверь",
      "sliding": "Раздвижная дверь",
      "yes": "Дверь"
    },
    "emergency": {
      "defibrillator": "Дефибриллятор",
      "fire_extinguisher": "Огнетушитель",
      "phone": "Телефон экстренной помощи"
    },
    "entrance": {
      "building": "Вход",
      "emergency": "Эвакуационный выход",
      "exit": "Выход",
      "home": "Вход",
      "main": "Вход",
      "service": "Служебный вход",
      "shop": "Вход",
      "staircase": "Вход",
      "yes": "Вход"
    },
    "exhibit": {
      "artwork": "Произведение искусства",
      "history": "История"
    },
    "highway": {
      "elevator": "Лифт"
    },
    "landuse": {
      "basin": "Искуственный водоём",
      "brownfield": "Заброшенная территория",
      "cemetery": "Кладбище",
      "reservoir": "Водохранилище",
      "winter_sports": "Зимние виды спорта"
    },
    "leisure": {
      "dog_park": "Площадка для выгула собак",
      "escape_game": "Игра «Побег»",
      "garden": "Сад",
      "golf_course": "Поле для гольфа",
      "hackerspace": "Хакерспейс",
      "ice_rink": "Ледовый каток",
      "marina": "Гавань",
      "miniature_golf": "Минигольф",
      "park": "Парк",
      "pitch": "Спортплощадка",
      "playground": "Детская площадка",
      "sports_centre": "Спортивный центр",
      "stadium": "Стадион",
      "swimming_area": "Место для купания",
      "swimming_pool": "Бассейн",
      "water_park": "Парк водных развлечений"
    },
    "office": {
      "government": "Правительство"
    },
    "railway": {
      "halt": "Полустанок",
      "station": "Станция",
      "subway_entrance": "Вход в метро",
      "train_station_entrance": "Вход на вокзал",
      "tram_stop": "Остановка трамвая"
    },
    "shop": {
      "accessories": "Аксесуары",
      "alcohol": "Алкоголь",
      "antiques": "Антиквариат",
      "art": "Предметы искусства",
      "bag": "Сумки",
      "bakery": "Пекарня",
      "beauty": "Салон красоты",
      "bed": "Кровати",
      "beverages": "Напитки",
      "bicycle": "Веломагазин",
      "books": "Книжный магазин",
      "boutique": "Бутик",
      "butcher": "Мясная лавка",
      "camera": "Фототовары",
      "car": "Автомагазин",
      "car_parts": "Автозапчасти",
      "car_repair": "Автомастерская",
      "carpet": "Ковры",
      "charity": "Благотворительный магазин",
      "cheese": "Сыр",
      "chemist": "Бытовая химия",
      "chocolate": "Шоколад",
      "clothes": "Одежда",
      "coffee": "Кофе",
      "computer": "Компьютеры и комплектующие",
      "confectionery": "Кондитерская",
      "convenience": "Магазин шаговой доступности",
      "copyshop": "Копировальный центр",
      "cosmetics": "Косметика",
      "deli": "Деликатесы",
      "delicatessen": "Деликатесы",
      "department_store": "Универмаг",
      "doityourself": "Строительные товары",
      "dry_cleaning": "Химчистка",
      "electronics": "Электроника",
      "erotic": "Эротические товары",
      "fabric": "Ткани",
      "fashion_accessories": "Модные аксесуары",
      "florist": "Флорист",
      "frame": "Багетная мастерская",
      "frozen_food": "Замороженые продукты",
      "furniture": "Магазин мебели",
      "garden_centre": "Садовые принадлежности",
      "general": "Универсальный магазин",
      "gift": "Магазин подарков",
      "greengrocer": "Магазин зелени",
      "hairdresser": "Парикмахерская",
      "hardware": "Хозяйственный магазин",
      "hearing_aids": "Слуховые аппараты",
      "hifi": "Hi-Fi аппаратура",
      "houseware": "Домашняя утварь",
      "ice_cream": "Мороженое",
      "interior_decoration": "Товары для интерьера",
      "jewelry": "Ювелирный магазин",
      "kiosk": "Киоск",
      "kitchen": "Кухни",
      "lamps": "Магазин света",
      "laundry": "Прачечная",
      "leather": "Изделия из кожи",
      "locksmith": "Замки",
      "mall": "Торговый центр",
      "massage": "Массажный салон",
      "mobile_phone": "Магазин мобильных телефонов",
      "motorcycle": "Мотоциклы",
      "music": "Музыкальный магазин",
      "musical_instrument": "Музыкальные инструменты",
      "newsagent": "Газеты и журналы",
      "optician": "Оптика",
      "outdoor": "Снаряжение для активного отдыха",
      "pastry": "Выпечка",
      "perfume": "Парфюмерия",
      "perfumery": "Парфюмерия",
      "pet": "Зоотовары",
      "photo": "Фототовары",
      "seafood": "Морские продукты",
      "second_hand": "Подержаные товары",
      "shoes": "Обувь",
      "sports": "Спортивные товары",
      "stationery": "Канцелярские товары",
      "supermarket": "Супермаркет",
      "tailor": "Портной",
      "tattoo": "Тату салон",
      "tea": "Чай",
      "ticket": "Продажа билетов",
      "tobacco": "Табак",
      "toys": "Игрушки",
      "travel_agency": "Турагенство",
      "variety_store": "Универсальный магазин",
      "video": "Видео товары",
      "video_games": "Видео игры",
      "watches": "Часы",
      "weapons": "Оружейный магазин",
      "wholesale": "Оптовый магазин",
      "wine": "Винный магазин"
    },
    "sport": {
      "american_football": "Американский футбол",
      "archery": "Стрельба из лука",
      "athletics": "Атлетика",
      "australian_football": "Австралийский футбол",
      "badminton": "Бадминтон",
      "baseball": "Бейсбол",
      "basketball": "Баскетбол",
      "beachvolleyball": "Пляжный воллейбол",
      "billiards": "Бильярд",
      "bmx": "BMX",
      "boules": "Шары",
      "bowls": "Игра в боулз",
      "boxing": "Бокс",
      "canadian_football": "Канадский футбол",
      "canoe": "Гребля на каноэ",
      "chess": "Шахматы",
      "climbing": "Скалолазание",
      "climbing_adventure": "Верёвочный парк",
      "cricket": "Крикет",
      "cricket_nets": "Сетки для крикета",
      "croquet": "Крокет",
      "curling": "Кёрлинг",
      "cycling": "Велоспорт",
      "disc_golf": "Диск-гольф",
      "diving": "Дайвинг",
      "dog_racing": "Собачьи бега",
      "equestrian": "Конный спорт",
      "fatsal": "Мини-футбол",
      "field_hockey": "Хоккей на траве",
      "free_flying": "Фрифлай",
      "gaelic_games": "Гэльские игры",
      "golf": "Гольф",
      "gymnastics": "Гимнастика",
      "handball": "Гандбол",
      "hockey": "Хоккей",
      "horse_racing": "Скачки",
      "horseshoes": "Подковы",
      "ice_hockey": "Хоккей на льду",
      "ice_stock": "Айсшток",
      "judo": "Дзюдо",
      "karting": "Картинг",
      "korfball": "Корфбол",
      "long_jump": "Прыжки в длину",
      "model_aerodrome": "Аэрополе для авиамоделей",
      "motocross": "Мотокросс",
      "motor": "Автомотоспорт",
      "multi": "Разные виды спорта",
      "netball": "Нетбол",
      "orienteering": "Спортивное ориентирование",
      "paddle_tennis": "Падел-теннис",
      "paintball": "Пейнтбол",
      "paragliding": "Парапланеризм",
      "pelota": "Пелота",
      "racquet": "Ракетбол",
      "rc_car": "RC автомоделизм",
      "rowing": "Гребля",
      "rugby": "Рэгби",
      "rugby_league": "Регбийная лига",
      "rugby_union": "Регбийный союз",
      "running": "Бег",
      "sailing": "Парусный спорт",
      "scuba_diving": "Подводное плавание",
      "shooting": "Спортивная стрельба",
      "shooting_range": "Тир",
      "skateboard": "Скейтборд",
      "skating": "Катание на коньках",
      "skiing": "Катание на лыжах",
      "soccer": "Футбол",
      "surfing": "Серфинг",
      "swimming": "Плавание",
      "table_soccer": "Настольный футбол",
      "table_tennis": "Настольный теннис",
      "team_handball": "Командный гандбол",
      "tennis": "Теннис",
      "toboggan": "Тобогган",
      "volleyball": "Волейбол",
      "water_ski": "Водные лыжи",
      "yoga": "Йога"
    },
    "tourism": {
      "alpine_hut": "Альпийский домик",
      "aquarium": "Аквариум",
      "artwork": "Произведение искусства",
      "attraction": "Аттракцион",
      "bed_and_breakfast": "Гостевой дом",
      "camp_site": "Кемпинг",
      "caravan_site": "Караван-парк",
      "chalet": "Шале",
      "gallery": "Галерея",
      "guest_house": "Гостевой дом",
      "hostel": "Хостел",
      "hotel": "Отель",
      "information": "Информационный указатель",
      "motel": "Мотель",
      "museum": "Музей",
      "picnic_site": "Место для пикника",
      "theme_park": "Тематический парк",
      "viewpoint": "Видовая точка",
      "zoo": "Зоопарк"
    }
  },
  "search": "Поиск",
  "sidebar": {
    "about": {
      "created_by": "Автор: François de Metz",
      "title": "О проекте"
    },
    "api": {
      "embed": {
        "cta": "Читать документацию",
        "subtitle": "Открыть интерактивный просмотрщик, предпросмотр файлов и прочее с помощью API",
        "title": "Встроить indoor="
      },
      "indoorequal": {
        "cta": "Регистрация",
        "subtitle": "Чтобы начать, создайте бесплатную учётную запись на indoorequal.com.",
        "title": "Отобразить векторные тайлы indoor="
      },
      "schema": {
        "cta": "Узнать больше",
        "subtitle": "Узнайте больше про схему векторных тайлов тайлов чтобы интегрировать их в любое приложение.",
        "title": "Подробнее про схему"
      },
      "subtitle": "Встраивайте indoor= в своё приложение",
      "title": "Разработчикам"
    },
    "collapse": "Свернуть",
    "description": "indoor= отображает схемы зданий из {0} и позволяет предпросматривать файлы GeoJSON, OSM и IMDF.",
    "explore": {
      "subtitle": "Примеры планов зданий",
      "title": "Посмотреть"
    },
    "last_update": "Последнее обновление данных {0}. {1}.",
    "status": "Текущий статус",
    "learn": {
      "subtitle": "Как разметить план здания в OpenStreetMap",
      "title": "Узнайте"
    },
    "news": {
      "subtitle": "Что нового в indoor=",
      "title": "Новости"
    },
    "preview": {
      "title": "Предпросмотр",
      "subtitle": "Посмотрите как будет выглядеть план перед загрузкой данных"
    },
    "taginfo": {
      "title": "indoor= на Taginfo",
      "subtitle": "Раздел, посвящённый внутренним планам"
    },
    "osm": "OpenStreetMap"
  },
  "preview": {
    "close": "Закрыть предпросмотр",
    "description": "Проверьте как будет отображаться ваш план здания. Выберите или перетяните файл osm  или GeoJSON созданный по правилам Простой схемы тегирования планов зданий.",
    "download": "Скачать файл для предпросмотра",
    "error": "Ошибка при отображении: {msg}.",
    "error_bad_file": "Не удалось прочитать файл",
    "error_no_level": "Не найдено элементов Внутренней схемы здания",
    "file": "Файл GeoJSON, osm или IMDF (zip)",
    "how": {
      "content1": "Открыть и отредактировать это место для в JOSM",
      "content2": "Нажмите \"Файл\" -> \"Сохранить как\" и сохраните файл в формате GeoJSON или osm.",
      "content3": "Выберите файл в форме ниже",
      "title": "Как"
    },
    "imdf": "Для предпросмотра также поддерживаются файлы IMDF.",
    "no_data_uploaded": "Никакие данные не загружаются на удалённые сервера. Всё обрабатывется на вашем компьютере.",
    "title": "Предпросмотр",
    "url": {
      "no": "Нет",
      "text": "Хотите загрузить файл для предпросмотр из {0}?",
      "title": "Загрузить файл для предпросмотра из интернета",
      "yes": "Да"
    }
  },
  "toolbar": {
    "edit": "Редактировать OpenStreetMap",
    "menu": "Меню",
    "view": "Просмотр карты",
    "zoom_to_edit": "Приблизьте чтобы перейти к редактированию"
  },
  "wheelchair": {
    "limited": "Частичная доступность",
    "no": "Не доступно",
    "yes": "Доступно на инвалидном кресле"
  },
  "zoom": "Приблизьте чтобы посмотреть планы зданий"
}
